import { render } from "./shippingStatusList.vue?vue&type=template&id=700466a8&scoped=true"
import script from "./shippingStatusList.vue?vue&type=script&lang=js"
export * from "./shippingStatusList.vue?vue&type=script&lang=js"

import "./shippingStatusList.vue?vue&type=style&index=0&id=700466a8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-700466a8"]])

export default __exports__